export enum SharedFormKeyNames {
  EMAIL = 'email',
  PREFERRED_NAME = 'preferredName',
  MOBILE_NUMBER = 'phoneNumber',
  NATIONALITY = 'nationality',
  DOB = 'dob',
  UNIVERSITY_ID = 'universityId',
  INTAKE_ID = 'intakeId',
  STUDY_LEVEL = 'studyLevel',
  FEE_STATUS = 'feeStatus',
  COURSE_ID = 'courseId',
  MODE = 'mode',
  CAMPUS = 'campus',
  ENTRY_POINT = 'entryPoint',
  COURSE_NAME = 'courseName',
  PROGRAMME_CHOICES = 'programmeChoices',
  DISABLE_EMAIL_NOTIFICATIONS = 'disableEmailNotifications',
}

export const PartnerFormKeyNames = { ...SharedFormKeyNames };

export const UniStaffFormKeyNames = { ...SharedFormKeyNames };

enum ExclusiveAgentFormKeyNames {
  AGENT_CONSENT = 'agentConsent',
}

export const AgentFormKeyNames = {
  ...SharedFormKeyNames,
  ...ExclusiveAgentFormKeyNames,
};
